module.exports = __webpack_public_path__ + "static/media/banner_420x230_7.e795d402.jpg";